import { isWebSocketChat } from './chat-config.js';

const activeChat = isWebSocketChat() ? require('./websocket.js') : require('./tim.js');

export const appID = 1400501212;
export const getTim = activeChat.getTim;
export const loginTim = activeChat.loginTim;
export const sendMessage = activeChat.sendMessage;
export const getMessageList = activeChat.getMessageList;
export const watchMessage = activeChat.watchMessage;

export default activeChat.default || activeChat;



// WEBPACK FOOTER //
// ./src/utils/tim-chat-adapter.js